<div class="error-modal-container">
  <div class="error-modal-icon">
    <mat-icon class="material-symbols-rounded outline">{{ data.icon || 'dangerous' }}</mat-icon>
  </div>
  
  <h4>{{ data.title || 'Error' }}</h4>
  
  <h6>{{ data.message || 'Ha ocurrido un error inesperado.' }}</h6>
  
  <div class="error-modal-actions">
    <button mat-stroked-button color="secondary" class="full-width" (click)="onClose()" class="cancel-btn">
      {{ data.buttonText || 'Aceptar' }}
    </button>
  </div>
</div>
